'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Radio = function Radio(_ref) {
  var label = _ref.label,
      name = _ref.name,
      value = _ref.value,
      _ref$id = _ref.id,
      id = _ref$id === undefined ? (0, _utils.idGen)('radio') : _ref$id,
      onChange = _ref.onChange,
      disabled = _ref.disabled,
      inputClassName = _ref.inputClassName,
      labelClassName = _ref.labelClassName,
      radioGroupValue = _ref.radioGroupValue;

  var checked = radioGroupValue === value;
  var handleChange = function handleChange() {
    if (!disabled && !checked) {
      if (onChange) {
        onChange(value);
      }
    }
  };
  return _react2.default.createElement(
    'div',
    { className: 'luna-form__selection' },
    _react2.default.createElement('input', {
      id: id,
      className: (0, _classnames2.default)('luna-radio', inputClassName),
      type: 'radio',
      name: name,
      value: value && (0, _utils.stringify)(value),
      checked: checked,
      disabled: disabled,
      onChange: handleChange
    }),
    _react2.default.createElement(
      'label',
      { className: (0, _classnames2.default)('luna-label', labelClassName), htmlFor: id },
      label
    )
  );
};

Radio.propTypes = {
  label: _propTypes2.default.string,
  id: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  name: _propTypes2.default.string,
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array, _propTypes2.default.number, _propTypes2.default.object]).isRequired,
  disabled: _propTypes2.default.bool,
  inputClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),
  labelClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)])
};

exports.default = Radio;


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/Radio/Radio.js